<div class="npdc-title">
  <h1>Placenames</h1>
  <div class="npdc-title__actions">
    @if (authService.canInvoke(authService.endpoints.createPlacename)) {
      <a mat-flat-button routerLink="new">New placename</a>
    }
  </div>
</div>

<p>
  This is the public
  <a href="https://data.npolar.no/dataset/a2813eb6-e866-4ef7-8808-ed09eb1566c5" target="_blank">
    registry
  </a>
  of official and historical place names in the Norwegian Arctic and in Antarctic territories.
  Norwegian place names in these regions are managed by the Norwegian Polar Institute's
  <a href="https://npolar.no/en/maps/polar-place-names/" target="_blank"> naming committee. </a>
</p>
<p>Names can be filtered by status or area using the button next to the search input.</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in placenames..."
      [value]="q()"
      (keydown.enter)="search($any($event).target?.value || '', location(), status(), area(), 0)"
    />
  </div>
  <button mat-icon-button matTooltip="Advanced search" (click)="openSearch()">
    <mat-icon>tune</mat-icon>
  </button>
</div>

@if (location() || status() || area()) {
  <p>
    <mat-chip-set>
      @if (location()) {
        <mat-chip highlighted>
          Custom location
          <mat-icon matChipRemove (click)="search(q(), '', status(), area(), 0)">cancel</mat-icon>
        </mat-chip>
      }
      @if (status()) {
        <mat-chip highlighted>
          {{ status() }}
          <mat-icon matChipRemove (click)="search(q(), location(), '', area(), 0)">cancel</mat-icon>
        </mat-chip>
      }
      @if (area()) {
        <mat-chip highlighted>
          {{ area() }}
          <mat-icon matChipRemove (click)="search(q(), location(), status(), '', 0)"
            >cancel</mat-icon
          >
        </mat-chip>
      }
    </mat-chip-set>
  </p>
}

<app-list [resource]="placenames" [disableClear]="!q() && !location() && !status() && !area()">
  @if (!placenames.error()) {
    <mat-nav-list>
      @for (p of placenames.value()?.items; track p.id) {
        <a mat-list-item routerLink="{{ p.id }}">
          <mat-icon matListItemIcon>location_on</mat-icon>
          <span matListItemTitle>{{ p.title }}</span>
          <span matListItemLine>{{ p.area || 'N/A' }}, {{ p.start }}</span>
          <span matListItemLine>{{ p.keywords.join(', ') || 'N/A' }}</span>
          @if (p.status === 'official') {
            <span matListItemMeta><mat-chip>{{ p.status | titlecase }}</mat-chip></span>
          }
          <!-- <span matListItemMeta> -->
          <!--   {{ p.created | date: 'yyyy-MM-dd' }} -->
          <!-- </span> -->
        </a>
      }

      <mat-paginator
        showFirstLastButtons
        (page)="search(q(), location(), status(), area(), $event.pageIndex, $event.pageSize)"
        [length]="count()"
        [pageIndex]="page()"
        [pageSize]="pageSize()"
        [pageSizeOptions]="[10, 20, 50, 100]"
      >
      </mat-paginator>
    </mat-nav-list>
  }
</app-list>
